import { version } from '../../package.json';

const Version = () => {
  return (
    <footer className="absolute mt-10 bottom-1 w-full flex items-center justify-center">
      <span className="text-xs text-gray-300 select-none">{version}</span>
    </footer>
  );
};

export default Version;
